import * as React from 'react';
import { CommentContainer } from '@centerpiece/components';
import {
  useCreateCommentMutation,
  useGetCommentsQuery,
  usePatchCommentMutation,
} from 'store/api';
import { Comment } from 'store/api/models';

export interface CommentsTabProps {
  afterSave?: Function;
  recipients?: any;
  foreignKey?: any;
  createAttributes?: any;
  comments?: Comment[];
  commentsLoading?: boolean;
}

export const CommentsTab = ({
  afterSave = () => {},
  recipients = [],
  foreignKey,
  createAttributes = foreignKey,
  commentsLoading,
  comments,
}: CommentsTabProps) => {
  const {
    data: qcomments = [],
    isLoading: qcommentsLoading,
    refetch: refetchComments,
  } = useGetCommentsQuery(
    { params: { nested: 'all', ...foreignKey } },
    { skip: !foreignKey || !!comments }
  );
  const [createComment] = useCreateCommentMutation();
  const [patchComment] = usePatchCommentMutation();

  return (
    <CommentContainer
      comments={comments || qcomments}
      recipients={(recipients || []).map((c: any) => ({
        ...c,
        name: `${c.contact_r?.firstname} ${c.contact_r?.lastname}`,
      }))}
      markRead={async () => {
        await patchComment({
          id: 0,
          ...foreignKey,
        } as any);
        await afterSave();
      }}
      commentsLoading={commentsLoading || qcommentsLoading}
      createComment={async (values: any) => {
        await createComment({
          comment: values.comment,
          ...createAttributes,
        });
      }}
    />
  );
};
